import React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { AccessForSelectFragment } from 'generated/resources/graphql'

import { AccessSelector } from 'modules/core/components/AccessSelector'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onInvite: (accessId: number) => void
  onClose: () => void
}

export const InviteUserModal = ({ onInvite, onClose }: Props) => {
  const [selectedAccess, setSelectedAccess] = React.useState<AccessForSelectFragment | null>(null)

  return (
    <Modal
      illustration="user-calendar"
      title={i18n.t('cronofy.invite_user.title')}
      description={i18n.t('cronofy.invite_user.description')}
      onClose={onClose}
      onSubmit={() => selectedAccess && onInvite(selectedAccess.id)}
      footer={
        <Box flexDirection="row" gap="s8">
          <Button type="secondary" disabled={false} onClick={onClose}>
            {i18n.t('cronofy.invite_user.cancel')}
          </Button>
          <Button disabled={!selectedAccess} submit>
            {i18n.t('cronofy.invite_user.invite')}
          </Button>
        </Box>
      }
    >
      <AccessSelector
        width="s400"
        mandatory
        value={selectedAccess}
        onSelect={(value) => {
          setSelectedAccess(value)
        }}
        multiple={false}
      />
    </Modal>
  )
}
